import { Relation, RelationType } from './relation';
import { Model } from '../../shared/models/model';

export function HasOne(type, field) {
    return (target) => {
        const currentRelations = Model.relations.get(target);
        if (currentRelations) {
            Model.relations.set(target, [...currentRelations, new Relation(type, field, RelationType.HasOne)]);
        } else {
            Model.relations.set(target, [new Relation(type, field, RelationType.HasOne)]);
        }
    };
};
